export default "__VITE_ASSET__CjIRX74e__"